import {observer} from "mobx-react-lite";
import {animation} from "../stores/AnimationStore";
import React from "react";

export const Rates = observer(() => {

    const changeRefreshRate = (e: any) => {
        animation.setRefreshRate(parseFloat(e.target.value));
    };

    const setRefreshRate = (n: number) => {
        animation.setRefreshRate(n);
    };

    const changeSpeed = (e: any) => {
        animation.setSpeed(parseFloat(e.target.value));
    };

    const setSpeed = (n: number) => {
        animation.setSpeed(n);
    };

    return (
        <div className="f mt10">
            <div className="f center">
                refresh:&nbsp;<button type="button" onClick={()=>setRefreshRate(1)}>1</button>
                <button type="button" onClick={()=>setRefreshRate(5)}>5</button>
                <button type="button" onClick={()=>setRefreshRate(10)}>10</button>
                <button type="button" onClick={()=>setRefreshRate(15)}>15</button>
                <button type="button" onClick={()=>setRefreshRate(20)}>20</button>
                <input type="range" min="0.1" max="30" value={animation.refreshRate} onChange={changeRefreshRate} /> {animation.refreshRate}
            </div>
            <div className="f ml20 center">
                animation:&nbsp;<button type="button" onClick={()=>setSpeed(0.5)}>0.5</button>
                <button type="button" onClick={()=>setSpeed(1)}>1</button>
                <button type="button" onClick={()=>setSpeed(2)}>2</button>
                <button type="button" onClick={()=>setSpeed(4)}>4</button>
                <button type="button" onClick={()=>setSpeed(10)}>10</button>
                <input type="range" min="0.1" max="20" value={animation.speed} onChange={changeSpeed} /> {animation.speed}
            </div>
        </div>

    );

});
